<template>
  <div id="contactInfo">
    <div class="content">
      <h4 class="info">
        <b class="info-title">טלפון:</b>
        <a href="tel:046275556" class="link" id="phone-link">
          04-6275556
          <b-icon pack="fas" icon="phone" size="is-small" id="phone-icon" />
        </a>
      </h4>
      <h4 class="info">
        <b class="info-title">כתובת:</b> הקרן 14, פרדס חנה-כרכור
      </h4>
      <h4 class="info">
        <b class="info-title">דואר אלקטרוני: </b>
        <a href="mailto:nofayelet@012.net.il" class="link">nofayelet@012.net.il</a>
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactInfo"
};
</script>

<style scoped>
#contactInfo {
  direction: rtl;
  padding-right: 0.8%;
}
.info {
  padding-top: 0.6vh;
}
.info-title {
  color: #003300;
}
.link {
  color: #006080;
}
#phone-icon {
  color: #009999;
  padding-right: 1vw;
}
</style>
